import React from 'react'
import { useCustom } from '../../../provider/context'
import { MyCarCommutingApplicationScene } from './MyCarCommutingApplicationScene'
import { useMutation, useQuery } from '@apollo/client'
import { ErrorComponent, ProgressSpinner } from '../../../components'
import {
  STAFF_GET_DOCTOR_CAR_COMMUTING_APPLICATION,
  STAFF_MUTATION_APPROVE_DOCTOR_CAR_COMMUTING_APPLICATION,
} from './MyCarCommutingApplication.graphql'
import moment from 'moment/moment'

export const MyCarCommutingApplication = ({ closeModal, match: {
  params: { id },
}, }) => {
  const [{ i18n, popup }] = useCustom()
  const [updateDoctorCarCommutingApplication] = useMutation(STAFF_MUTATION_APPROVE_DOCTOR_CAR_COMMUTING_APPLICATION)

  const variables = {
    orderBy: 'createdAt_DESC',
    where: {
      deletedAt: null,
      doctor: id,
    },
  }

  const { loading, error, data } = useQuery(STAFF_GET_DOCTOR_CAR_COMMUTING_APPLICATION, {
    variables,
    fetchPolicy: 'network-only',
  })

  const onSubmit = async (e,actions) => {
    const { msg, type, id: nodeId } = e

    const variables = {
      msg,
      id:nodeId,
      doctorId: id
    }

    try {
      actions.setSubmitting(true);

      let result = {};
      switch (type) {
        case 'first-check':
          result = await updateDoctorCarCommutingApplication({
            variables: {
              ...variables,
              status: 'FIRST_APPROVAL_GRANTED'
            }
          })
          break;
        case 'approve':
          result = await updateDoctorCarCommutingApplication({
            variables: {
              ...variables,
              status: 'APPROVED',
              vehicleType: e.vehicleType,
              backSideLicenseKey: e.backSideLicenseKey,
              frontSideLicenseKey: e.frontSideLicenseKey,
              isAllowSendMailConfirm: e.isAllowSendMailConfirm,
              licensePlateNumberPart1: e.licensePlateNumberPart1,
              licensePlateNumberPart2: e.licensePlateNumberPart2,
              licensePlateNumberPart3: e.licensePlateNumberPart3,
              licensePlateNumberPart4: e.licensePlateNumberPart4,
              vehicleInspectionCertificateKey: e.vehicleInspectionCertificateKey,
              expirationDate: moment(e.expirationDate).format('YYYY-MM-DD'),
              carCommuteStartDate: moment(e.carCommuteStartDate).format('YYYY-MM-DD'),
              liabilityInsuranceCertificateKey: e.liabilityInsuranceCertificateKey,
              voluntaryInsuranceCertificateKey: e.voluntaryInsuranceCertificateKey,
              vehicleInspectionExpirationDate: moment(e.vehicleInspectionExpirationDate).format('YYYY-MM-DD'),
              liabilityInsuranceCertificateExpirationDate: moment(e.liabilityInsuranceCertificateExpirationDate).format('YYYY-MM-DD'),
              voluntaryInsuranceCertificateExpirationDate: moment(e.voluntaryInsuranceCertificateExpirationDate).format('YYYY-MM-DD')
            }
          })
          break;
        case 'resend':
          result = await updateDoctorCarCommutingApplication({
            variables: {
              ...variables,
              status: 'RESUBMIT_REQUEST'
            }
          })
          break;
        default:
          popup.error('無効なステータス')
          break;
      }
      const {data: {staffUpdateDoctorCarCommutingApplication: resultMsg}} = result

      if (resultMsg !== '') {
        popup.error(resultMsg)
      }else {
        popup.success('成功しました')
        actions.resetForm();
        closeModal()
      }
    } catch (error) {
      popup.error(error)
    } finally {
      setTimeout(() => { actions.setSubmitting(false) }, 1500)
    }
  }

  if (loading) return <ProgressSpinner />
  if (error) return <ErrorComponent error={error} />

  return (
    <MyCarCommutingApplicationScene
      i18n={i18n}
      popup={popup}
      data={data?.myCarCommutingApplications}
      isApproved={false}
      onSubmit={onSubmit}
    />
  )
}